import { ResourceType } from '__types__';
import store from '../../../../store';
import { RESOURCE_TYPES_ACTIONS } from '../../../../store/v1/resource_types/resource_types.constants.js';
import {
  resourceTypeBindingSourceRow$,
  type ResourceTypeWorkspaceRelation
} from 'v5/api/resource-types/resource-type-bindings.schema';

/**
 * Redux still stores settings join extras on each type row at runtime.
 * That field is not on {@link ResourceType}; only bindings sync writes it
 * explicitly. Type CRUD preserves the cached bag; malformed rows throw.
 */
type ResourceTypeReduxRow = ResourceType & {
  enterprise_workspaces?: ResourceTypeWorkspaceRelation[];
};

function readPreviousWorkspaceRelations(
  id: number
): ResourceTypeWorkspaceRelation[] | undefined {
  const state = store.getState() as {
    resource_types?: { data?: Record<number, unknown> };
  };
  const row = state.resource_types?.data?.[id];
  if (row === undefined) {
    return undefined;
  }
  return resourceTypeBindingSourceRow$.parse(row).enterprise_workspaces;
}

function withPreservedWorkspaceRelations(
  result: ResourceType,
  workspaceRelations?: ResourceTypeWorkspaceRelation[]
): ResourceTypeReduxRow {
  if (workspaceRelations !== undefined) {
    return { ...result, enterprise_workspaces: workspaceRelations };
  }
  const previous = readPreviousWorkspaceRelations(result.id);
  if (previous === undefined) {
    return result;
  }
  return {
    ...result,
    enterprise_workspaces: previous
  };
}

export function syncResourceTypeCreatedToRedux(result: ResourceType) {
  store.dispatch({
    type: RESOURCE_TYPES_ACTIONS.CREATE_RESOURCE_TYPE_SUCCESS,
    result
  });
}

export function syncResourceTypeUpdatedToRedux(
  result: ResourceType,
  options?: { workspaceRelations?: ResourceTypeWorkspaceRelation[] }
) {
  store.dispatch({
    type: RESOURCE_TYPES_ACTIONS.UPDATE_RESOURCE_TYPE_SUCCESS,
    result: withPreservedWorkspaceRelations(result, options?.workspaceRelations)
  });
}

export function syncResourceTypeDeletedToRedux(id: number) {
  store.dispatch({
    type: RESOURCE_TYPES_ACTIONS.DELETE_RESOURCE_TYPE_SUCCESS,
    id
  });
}

export function syncResourceTypeOrderToRedux(result: ResourceType[]) {
  store.dispatch({
    type: RESOURCE_TYPES_ACTIONS.UPDATE_RESOURCE_TYPE_ORDER_SUCCESS,
    result
  });
}
